import axiosInstance from "../utils/axiosInstance";
import { CookieUtils } from "../utils";

class CalculateService {
  async rate(params) {
    try {
      const req = {
        operationName: null,
        query: `query MtiCalculateRate($typeCode: String, $plan: String, $day: Int, $zone: String, $age: Int, $counter: Int, $options: String) {
            mtiCalculateRate(type_code: $typeCode, plan: $plan, day: $day, zone: $zone, age: $age, counter: $counter, options: $options) {
              success
              message
              payload {
                id
                packageCode
                name
                product_name
                plan_package
                group_2
                insured
                price
                stamp
                vat
                total
                minAge
                maxAge
                option
              }
            }
          }`,
        variables: {
          typeCode: params.type_code,
          plan: params.plan,
          day: params.day,
          zone: params.zone,
          age: params.age,
          counter: params.counter,
          options: params.options,
        },
      };
      
      const accessToken = CookieUtils.getCookie("gtt_access_token");
      
      return axiosInstance
        .post("", req, { 
          headers: { 
            authorization: accessToken,
          } 
        })
        .then(({ data }) => {
          if (data?.data?.mtiCalculateRate.success) {
            return data?.data?.mtiCalculateRate.payload || {};
          } else {
            throw new Error(data.data.mtiCalculateRate.message);
          }
        });
    } catch (error) {
      // handle error
      console.log(error);
    }
  }
}

export default new CalculateService();
